module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-campgrounds-0c87627cd35dbe4f32d98bd32d182670.svg";